import { getCurrentZoneAbbr, getCurrentZoneAbbrInHour } from 'wisestep-base';

export const formattingRules = {
  '-12:00': { decimalSeparator: '.', thousandsSeparator: ',' }, // General (e.g., Kiribati)
  '-11:00': { decimalSeparator: '.', thousandsSeparator: ',' }, // General (e.g., American Samoa)
  '-10:00': { decimalSeparator: '.', thousandsSeparator: ',' }, // General (e.g., Hawaii)
  '-09:30': { decimalSeparator: '.', thousandsSeparator: '.' }, // French Polynesia
  '-09:00': { decimalSeparator: '.', thousandsSeparator: ',' }, // General (e.g., Alaska)
  '-08:00': { decimalSeparator: '.', thousandsSeparator: ',' }, // General (e.g., Pacific Time)
  '-07:00': { decimalSeparator: '.', thousandsSeparator: ',' }, // General (e.g., Mountain Time)
  '-06:00': { decimalSeparator: '.', thousandsSeparator: ',' }, // General (e.g., Central Time)
  '-05:00': { decimalSeparator: '.', thousandsSeparator: ',' }, // General (e.g., Eastern Time)
  '-04:30': { decimalSeparator: '.', thousandsSeparator: '.' }, // Venezuela
  '-04:00': { decimalSeparator: '.', thousandsSeparator: ',' }, // General (e.g., Atlantic Time)
  '-03:30': { decimalSeparator: '.', thousandsSeparator: '.' }, // Newfoundland and Labrador
  '-03:00': { decimalSeparator: '.', thousandsSeparator: ',' }, // General (e.g., Brasília Time)
  '-02:00': { decimalSeparator: '.', thousandsSeparator: '.' }, // General (e.g., Fernando de Noronha)
  '-01:00': { decimalSeparator: '.', thousandsSeparator: ',' }, // General (e.g., Azores)
  '±00:00': { decimalSeparator: '.', thousandsSeparator: ',' }, // General (e.g., Coordinated Universal Time)
  '+01:00': { decimalSeparator: '.', thousandsSeparator: ',' }, // General (e.g., Central European Time)
  '+02:00': { decimalSeparator: '.', thousandsSeparator: '.' }, // General (e.g., Eastern European Time)
  '+03:00': { decimalSeparator: '.', thousandsSeparator: ',' }, // General (e.g., Moscow Time)
  '+03:30': { decimalSeparator: '.', thousandsSeparator: ',' }, // Iran
  '+04:00': { decimalSeparator: '.', thousandsSeparator: ',' }, // General (e.g., Azerbaijan Time)
  '+04:30': { decimalSeparator: '.', thousandsSeparator: '.' }, // Afghanistan
  '+05:00': { decimalSeparator: '.', thousandsSeparator: ',' }, // General (e.g., Pakistan Time)
  '+05:30': { decimalSeparator: '.', thousandsSeparator: ',' }, // India, Sri Lanka
  '+05:45': { decimalSeparator: '.', thousandsSeparator: "'" }, // Nepal
  '+06:00': { decimalSeparator: '.', thousandsSeparator: ',' }, // General (e.g., Bangladesh Time)
  '+06:30': { decimalSeparator: '.', thousandsSeparator: ',' }, // General (e.g., Cocos Islands)
  '+07:00': { decimalSeparator: '.', thousandsSeparator: ',' }, // General (e.g., Indochina Time)
  '+08:00': { decimalSeparator: '.', thousandsSeparator: ',' }, // General (e.g., China Standard Time)
  '+08:30': { decimalSeparator: '.', thousandsSeparator: ',' }, // North Korea
  '+08:45': { decimalSeparator: '.', thousandsSeparator: "'" }, // Australia (Eucla)
  '+09:00': { decimalSeparator: ',', thousandsSeparator: '.' }, // General (e.g., Japan Standard Time)
  '+09:30': { decimalSeparator: ',', thousandsSeparator: '.' }, // Australia (Central Standard Time)
  '+10:00': { decimalSeparator: '.', thousandsSeparator: ',' }, // General (e.g., Papua New Guinea Time)
  '+10:30': { decimalSeparator: '.', thousandsSeparator: ',' }, // Lord Howe Island
  '+11:00': { decimalSeparator: '.', thousandsSeparator: ',' }, // General (e.g., Solomon Islands Time)
  '+12:00': { decimalSeparator: '.', thousandsSeparator: ',' }, // General (e.g., New Zealand Time)
  '+13:00': { decimalSeparator: '.', thousandsSeparator: ',' }, // General (e.g., Line Islands)
};

export const convertToMetricSystem = (number: number): number =>
  number / Math.pow(1000, Number(getCurrentZoneAbbrInHour()));

export const formatNumberInLocale = (num: number) => {
  try {
    const timeZone = getCurrentZoneAbbr();
    const rules = formattingRules[timeZone];
    const formattedNumber: string = num
      .toLocaleString()
      .replace('.', rules.decimalSeparator)
      .replace(',', rules.thousandsSeparator);
    return formattedNumber;
  } catch {
    return num;
  }
};
